import { Button } from "@/components/ui/button";

export function PageHeader({ title, subtitle, action, testid }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6" data-testid={testid || "page-header"}>
      <div>
        <h1 className="font-display font-bold tracking-tight text-2xl md:text-3xl text-gray-900">{title}</h1>
        {subtitle ? <p className="text-sm text-gray-500 mt-1">{subtitle}</p> : null}
      </div>
      {action ? <div>{action}</div> : null}
    </div>
  );
}

export function EmptyState({ title, description, action }) {
  return (
    <div className="crm-card p-12 flex flex-col items-center justify-center text-center" data-testid="empty-state">
      <h3 className="font-display text-lg font-semibold text-gray-900">{title}</h3>
      {description ? <p className="text-sm text-gray-500 mt-1 max-w-md">{description}</p> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}

export function StatusBadge({ value, scheme = "neutral" }) {
  const map = {
    open: "bg-blue-50 text-blue-700 border-blue-200",
    in_progress: "bg-amber-50 text-amber-700 border-amber-200",
    done: "bg-emerald-50 text-emerald-700 border-emerald-200",
    cancelled: "bg-gray-100 text-gray-600 border-gray-200",
    new: "bg-blue-50 text-blue-700 border-blue-200",
    contacted: "bg-violet-50 text-violet-700 border-violet-200",
    qualified: "bg-amber-50 text-amber-700 border-amber-200",
    won: "bg-emerald-50 text-emerald-700 border-emerald-200",
    lost: "bg-rose-50 text-rose-700 border-rose-200",
    draft: "bg-gray-100 text-gray-600 border-gray-200",
    sent: "bg-blue-50 text-blue-700 border-blue-200",
    accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
    rejected: "bg-rose-50 text-rose-700 border-rose-200",
    high: "bg-rose-50 text-rose-700 border-rose-200",
    medium: "bg-amber-50 text-amber-700 border-amber-200",
    low: "bg-gray-100 text-gray-600 border-gray-200",
    neutral: "bg-gray-100 text-gray-600 border-gray-200",
  };
  const labelMap = {
    open: "Offen",
    in_progress: "In Arbeit",
    done: "Erledigt",
    cancelled: "Abgebrochen",
    new: "Neu",
    contacted: "Kontaktiert",
    qualified: "Qualifiziert",
    won: "Gewonnen",
    lost: "Verloren",
    draft: "Entwurf",
    sent: "Versendet",
    accepted: "Angenommen",
    rejected: "Abgelehnt",
    high: "Hoch",
    medium: "Mittel",
    low: "Niedrig",
  };
  const cls = map[value] || map[scheme] || map.neutral;
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium border ${cls}`}>
      {labelMap[value] || value}
    </span>
  );
}

export function PrimaryButton({ children, ...props }) {
  return (
    <Button
      className="bg-black text-white hover:bg-gray-800 active:scale-[0.98] transition-all"
      {...props}
    >
      {children}
    </Button>
  );
}
